import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IProjectStatsFiltersStore } from '../filters/ProjectStatsFilters.store';
import { AnnotationToolsSection } from './AnnotationToolsSection';

export const AnnotationToolsSectionContainer = observer((): ReactElement => {
  const filtersStore = useInjection(IProjectStatsFiltersStore.$);

  return (
    <AnnotationToolsSection
      endDate={filtersStore.endDate}
      startDate={filtersStore.startDate}
    />
  );
});
